
export default {
    "请选择状态": "Please select status",
    "订阅": "Subscribe",
    "进入直播间": "Watch Now",
    "进入回看": "Recap",
    "订阅成功": "Subscribed",
    "订阅直播": "Subscribe",
    "直播详情页": "Live Detail Page",
    "嘉宾": "Guest",
    "直播嘉宾": "Live Guest",
    "直播详情": "Live Details",
    "直播合作": "Partnership",
    "已订阅": "Subscribed",
    "直播中": "Live Now",
    "即将开始": "Upcoming",
    "推荐直播": "Recommended Lives",
    "取消订阅成功": "Unsubscribed",
    "您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。": "Successfully subscribed! You\'ll be notified with SMS, WeChat & MANA app 15 minutes before the live start.",
    "您已成功取消订阅直播提醒，将不再收到该直播开始的通知。": "Successfully unsubscribed! You will no longer be notified.",
    "取消订阅": "Unsubscribe",
    "参与的直播": "Participated Lives",
    "还没有参与的直播": "No Participated Lives",
    "直播预告": "Upcoming",
    "TA正在直播": "Live Now",
    "开播前短信/服务号/App通知": "Notification with SMS/WeChat/APP before live streaming",

    "我的订单": "My Orders",
    "订单详情": "Order Details",
    "立即购买": "Buy Now",
    "商品": "Items",
    "单价(元)": "Price/Item(RMB)",
    "实付金额(元)": "Paid Amount(RMB)",
    "交易状态": "Transaction Status",
    "操作": "Actions",
    "订单编号": "Order No.",
    "直播": "Live",
    "去支付": "Pay Now",
    "取消订单": "Cancel",
    "申请售后": "Customer Service",
    "请联系网站底部在线客服或服务热线": "Please contact through live chat or service phone ",
    "是否取消该订单？": "Confirm to cancel the order?",
    "是": "Yes",
    "否": "No",
    "全部": "All",
    "待支付": "Pending Payment",
    "已支付": "Paid",
    "已退款": "Refunded",
    "已取消": "Canceled",
    "确认订单": "Confirm",
    "商品详情": "Item Detail",
    "价格": "Price",
    "开始时间": "Begin",
    "总计": "Total",
    "支付方式": "Pay with",
    "立即支付": "Pay Now",
    "提交订单即表示您已同意": "By submitting the order, you agree to",
    "《吗呐平台商品交易服务协议》": "《MANA Transaction Agreement》",
    "请在": "",
    "内完成支付": " left to make the payment",
    "支付成功": "Successfully paid",
    "后自动进入直播间": " left to enter Live room",
    "查看订单": "See Details",
    "微信付款": "Wechat Payment",
    "实付金额": "Actual Payment",
    "请在15分钟内完成付款": "Please pay within 15 minutes",
    "请使用微信扫一扫": "Scan with Wechat",
    "扫描二维码以完成支付": "Scan the QR code to finish payment",
    "榜单": "Trends",
    "MANA榜单": "MANA Trends",
    "每天上午10:00点前更新": "Update daily before 10:00 am",
    "周榜": "Weekly",
    "月榜": "Monthly",
    "总榜": "All",
    "MANA榜单周榜 TOP10": "MANA Weekly Trends TOP10",
    "MANA榜单周榜 TOP": "MANA Weekly Trends TOP",
    "MANA榜单月榜 TOP30": "MANA Monthly Trends TOP30",
    "MANA榜单月榜 TOP": "MANA Monthly Trends TOP",
    "MANA榜单总榜 TOP100": "MANA Trends TOP100",
    "MANA榜单总榜 TOP": "MANA Trends TOP",
}



// WEBPACK FOOTER //
// ./src/languages/en/live.js